const {
    buildQuery,
    getParams,
    removeParam
} = require('../utils/Url');
const { getImageSrc } = require('../utils/Image');
const { IMAGE_SIZES } = require('../utils/BCC');
const {
    IMAGE_SIZES: {
        LARGE,
        ZOOM
    }
} = require('../components/ProductPage/ProductMediaCarousel/constants');
const {
    MEDIA_TYPE: {
        IMAGE,
        VIDEO
    }
} = require('../analytics/constants');
const { supplementAltTextWithProduct } = require('../utils/Accessibility');
const JsUtils = require('../utils/javascript');
const LocaleUtils = require('../utils/LanguageLocale');
const SkuUtils = require('../utils/Sku');
const UrlUtils = require('../utils/Url');


const buildProductImageSrc = ({
    skuImages, src, hideBadge, id, size, generateSrcs
}) => {
    const srcWithParams = skuImages ?
        (skuImages['image' + IMAGE_SIZES['450']] || skuImages.image || src) :
        src;
    const urlParams = srcWithParams ? getParams(srcWithParams) : {};
    let imageSrc = src || `/productimages/sku/s${id}-main-zoom.jpg${buildQuery(JsUtils.buildMap(urlParams))}`;

    if (hideBadge) {
        imageSrc = removeParam(imageSrc, 'pb');
    }

    const sizes = Array.isArray(size) ? size.slice(1) : null;
    let imageSrcX1 = '';
    let imageSrcX2 = '';

    if (generateSrcs) {
        const newImageSize = sizes ? size[0] : size;
        imageSrcX1 = getImageSrc(imageSrc, newImageSize);
        imageSrcX2 = getImageSrc(imageSrc, newImageSize * 2);
    }

    return [imageSrc, sizes, imageSrcX1, imageSrcX2];
};

const buildProductHeroImageSrc = item => {
    let src = UrlUtils.getImagePath(SkuUtils.getImgSrc(ZOOM, item.media));
    src = removeParam(src, 'pb');
    const symbol = Object.keys(getParams(src)).length ? '&' : '?';
    const imageSource = `${src + symbol}imwidth=${LARGE}`;
    const imageSourceX2 = `${src + symbol}imwidth=${LARGE * 2}`;

    return [imageSource, imageSourceX2];
};

const getMediaItems = (product) => {
    /* eslint-disable prefer-const */
    let {
        currentSku,
        hoveredSku,
        productVideos = []
    } = product;
    let {
        alternateImages = [],
        skuImages
    } = (hoveredSku || currentSku);
    /* eslint-enable prefer-const */

    const altText = supplementAltTextWithProduct(currentSku, product);

    // Hero Image
    let mediaListItems = skuImages ? [{
        type: IMAGE,
        media: skuImages
    }] : [];

    // 2nd slot is for Sephora Virtual Artist, if enabled
    if (mediaListItems.length) {
        mediaListItems[0].media.altText = altText;

        if (Array.isArray(alternateImages) && alternateImages.length) {
            alternateImages = alternateImages.slice();
            mediaListItems.push({
                type: IMAGE,
                media: alternateImages.shift()
            });
        }
    }

    // Next slot is for First Product video (only for Desktop)
    productVideos = productVideos.slice();

    // Display certain videos for FR CA:
    if (productVideos.length) {
        productVideos = productVideos.filter(item =>
            !item.styleList ||
            (LocaleUtils.isFRCanada() && item.styleList['FR_CA_SHOW'] !== undefined) ||
            (!LocaleUtils.isFRCanada() && item.styleList['FR_CA_HIDE'] !== undefined)
        );

    }

    if (productVideos.length) {
        mediaListItems.push({
            type: VIDEO,
            media: productVideos.shift()
        });
    }

    // All the Alt images go next
    alternateImages = alternateImages.slice();
    mediaListItems = mediaListItems.concat(alternateImages.map(item => ({
        type: IMAGE,
        media: item
    })));

    // All the remaining videos
    productVideos = productVideos.map(item => ({
        type: VIDEO,
        media: item
    }));

    mediaListItems = mediaListItems.concat(productVideos);
    return mediaListItems;
};

module.exports = {
    buildProductHeroImageSrc,
    buildProductImageSrc,
    getMediaItems
};
